// extracted by mini-css-extract-plugin
module.exports = {"offer":"Offer_offer__3l7D3","icon":"Offer_icon__1CXhM","flex":"Offer_flex__10PDk"};